module.exports = __webpack_public_path__ + "img/8bf8063.png";